import { Last6MonthsLendingOutboundPackageVolumeWeekdayHeatmapChart } from '../../../statistics/lending/last-6-months-lending-outbound-package-volume-weekday-heatmap-chart/last-6-months-lending-outbound-package-volume-weekday-heatmap-chart.component';
import { Last6MonthsLendingReturnPackageVolumeWeekdayHeatmapChart } from '../../../statistics/lending/last-6-months-lending-return-package-volume-weekday-heatmap-chart/last-6-months-lending-return-package-volume-weekday-heatmap-chart.component';
import { Last30DaysLendingAverageUseDurationByProductListCard } from '../../../statistics/lending/last-30-days-lending-average-use-duration-by-product-list-card/last-30-days-lending-average-use-duration-by-product-list-card.component';
import { Last60DaysLendingOutboundPackageVolumeByProductMonthlyListChart } from '../../../statistics/lending/last-60-days-lending-outbound-package-volume-by-product-monthly-list-chart/last-60-days-lending-outbound-package-volume-by-product-monthly-list-chart.component';
import { INSIGHTS_GRID_CLASS_NAME, getInsightCardWidthClass } from '../insight-card-width';
import { InsightDetailChrome } from '../insight-detail-chrome.component';
import { InsightId } from '../insight-registry/insight-ids';
import { LendingEquipmentUsageHoursList } from './lending-equipment-usage-hours-list.component';
import { LendingEquipmentUsesVolumeByProductList } from './lending-equipment-uses-volume-by-product-list.component';
import { LendingOutboundPackageVolumeHourDayHeatmapChart } from './lending-outbound-package-volume-hour-day-heatmap-chart.component';
import { LendingReturnPackageVolumeHourDayHeatmapChart } from './lending-return-package-volume-hour-day-heatmap-chart.component';

export interface LendingInsightsPageProps {
    accountId: string;
}

/** Standalone Lending insights content — reusable outside Analytics. */
export const LendingInsightsPage = ({ accountId }: LendingInsightsPageProps) => (
    <div className={INSIGHTS_GRID_CLASS_NAME}>
        <LendingEquipmentUsesVolumeByProductList
            accountId={accountId}
            width={2}
        />
        <div className={getInsightCardWidthClass(2)}>
            <InsightDetailChrome insightId={InsightId.LENDING_EQUIPMENT_POPULARITY}>
                <Last60DaysLendingOutboundPackageVolumeByProductMonthlyListChart accountId={accountId} />
            </InsightDetailChrome>
        </div>
        <div className={getInsightCardWidthClass(2)}>
            <InsightDetailChrome insightId={InsightId.LENDING_AVERAGE_DURATION}>
                <Last30DaysLendingAverageUseDurationByProductListCard accountId={accountId} />
            </InsightDetailChrome>
        </div>
        <LendingEquipmentUsageHoursList
            accountId={accountId}
            width={2}
        />
        <LendingOutboundPackageVolumeHourDayHeatmapChart
            accountId={accountId}
            width={2}
        />
        <LendingReturnPackageVolumeHourDayHeatmapChart
            accountId={accountId}
            width={2}
        />
        <div className={getInsightCardWidthClass(2)}>
            <InsightDetailChrome insightId={InsightId.LENDING_OUTGOING_HEATMAP}>
                <Last6MonthsLendingOutboundPackageVolumeWeekdayHeatmapChart accountId={accountId} />
            </InsightDetailChrome>
        </div>
        <div className={getInsightCardWidthClass(2)}>
            <InsightDetailChrome insightId={InsightId.LENDING_INCOMING_HEATMAP}>
                <Last6MonthsLendingReturnPackageVolumeWeekdayHeatmapChart accountId={accountId} />
            </InsightDetailChrome>
        </div>
    </div>
);
